<template>
  <div class="promote-page common-bg" v-if="tabList.length > 0">
    <div class="header" style="background: #292a2c;">
      <div class="back" @click="$router.back()">
        <van-icon name="arrow-left" color="#BEBEBE" size="16"/>
      </div>
      <div class="title">分享赚钱</div>
      <div class="placeholder"></div>
    </div>

    <div class="tabs-wrapper">
      <van-tabs v-model="activeTab" class="topsa" background="#292A2C" title-active-color="#DFB372" title-inactive-color="#fff">
        <van-tab v-for="(item, index) in tabList" :name="index" :title="item.name" :key="index"> </van-tab>
      </van-tabs>
    </div>

    <div class="promote-content" >
      <promoteHome v-if="activeTab === 0"></promoteHome>
      <promoteShare v-if="activeTab === 1"></promoteShare>
      <promoteData v-if="activeTab === 2"></promoteData>
      <promotePerformance v-if="activeTab === 3"></promotePerformance>
      <promoteCommission v-if="activeTab === 4"></promoteCommission>
      <promoteSubInfo v-if="activeTab === 5"></promoteSubInfo>
      <promoteSubBet v-if="activeTab === 6"></promoteSubBet>
      <promoteSubFinance v-if="activeTab === 7"></promoteSubFinance>
      <promoteSubReceive v-if="activeTab === 8"></promoteSubReceive>
      <promoteCreateSub v-if="activeTab === 9"></promoteCreateSub>
      <promoteRebate v-if="activeTab === 10"></promoteRebate>
    </div>
  </div>
</template>

<script>
import promoteHome from "../component/promote/Home.vue"
import promoteShare from "../component/promote/Share.vue"
import promoteData from "../component/promote/Data.vue"
import promotePerformance from "../component/promote/Performance.vue"
import promoteCommission from "../component/promote/Commission.vue"
import promoteSubInfo from "../component/promote/SubInfo.vue"
import promoteSubBet from "../component/promote/SubBet.vue"
import promoteSubFinance from "../component/promote/SubFinance.vue"
import promoteSubReceive from "../component/promote/SubReceive.vue"
import promoteCreateSub from "../component/promote/CreateSub.vue"
import promoteRebate from "../component/promote/Rebate.vue"

export default {
  name: 'promote',
  components: {
    promoteHome,
    promoteShare,
    promoteData,
    promotePerformance,
    promoteCommission,
    promoteSubInfo,
    promoteSubBet,
    promoteSubFinance,
    promoteSubReceive,
    promoteCreateSub,
    promoteRebate,
  },
  data() {
    return {
      activeTab: 0,
      tabList: [
        { name: '首页', key: 'home' },
        { name: '推广分享', key: 'share' },
        { name: '我的数据', key: 'data' },
        { name: '我的业绩', key: 'performance' },
        { name: '我的佣金', key: 'commission' },
        { name: '下级信息', key: 'subInfo' },
        { name: '下级下注', key: 'subBet' },
        { name: '下级财务', key: 'subFinance' },
        { name: '下级领取', key: 'subReceive' },
        { name: '创建下级', key: 'createSub' },
        { name: '返佣比例', key: 'rebate' },
      ],
    };
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/common.css';
.promote-page {
  min-height: 100vh;
  overflow: hidden;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 200;
  padding: 0 0.3rem;

  .back {
    width: 0.8rem;
    height: 44px;
    line-height: 55px;
    text-align: center;
  }

  .title {
    flex: 1;
    text-align: center;
    color: #fff;
    font-size: 0.35rem;
    font-weight: bold;
  }

  .placeholder {
    width: 0.8rem;
  }
}
.tabs-wrapper {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  z-index: 190;
  background: #292A2C;

  .topsa {
    :deep(.van-tabs__nav) {
      overflow-x: auto;
      overflow-y: hidden;
      background: #292A2C !important;
      white-space: nowrap;
    }

    :deep(.van-tabs__active-bar) {
      background: #DFB372 !important;
      height: 3px;
    }

    :deep(.van-tabs__line) {
      background-color: #DFB372 !important;
    }

    :deep(.van-tab) {
      color: #888 !important;
      font-size: 0.26rem;
      flex: none;
      padding: 0 0.15rem;
    }

    :deep(.van-tab--active) {
      color: #DFB372 !important;
    }
  }
}
.promote-content {
  margin-top: 98px;
  min-height: calc(100vh - 98px);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/promote.vue